/* generated by pull.js */
const manifest = {
  "name": "Project video recorder",
  "description": "Adds a \"start recording\" button to the editor menu bar that allows you to record the project's stage.",
  "tags": [
    "recommended"
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "enabledByDefault": true
};
import {mediaRecorderSupported} from "../../environment";
if (!mediaRecorderSupported) manifest.unsupported = true;
export default manifest;
